import styled from "styled-components";

export const ImageBox = styled.img`
	height: 100%;
	width: 100%;
`;
